<template>
  <div class="mb-2" :class="{ 'is-invalid': validateState === false }">
    <vSelect
      class="custom-vue-select"
      :class="{ 'is-invalid': validateState === false }"
      :options="options"
      :disabled="disabled ? disabled : false"
      :clearable="clearable ? clearable : false"
      :multiple="multiple"
      :value="value"
      :reduce="options => (reduceKey ? options[reduceKey] : options.id)"
      :selectable="isSelectable"
      label="name"
      @input="setSelected"
      @option:selected="$emit('option:selected', $event)"
      @search:blur="$emit('search-blur')"
      v-bind="$attrs"
      :appendToBody="appendToBody"
    ></vSelect>
    <span
      v-if="validateState === false"
      class="text-danger mt-1 d-block"
      style="font-size: 12px;"
    >
      {{ $t("VALIDATION.INVALID", { name: "" }) }}
    </span>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "FormSelect",
  inheritAttrs: false,
  props: {
    options: {
      type: Array,
      required: true
    },
    disabled: Boolean,
    clearable: Boolean,
    multiple: Boolean,
    value: {},
    reduceKey: String,
    feedback_id: {
      type: String,
      default: ""
    },
    i18n: {
      type: Object,
      default: () => ({})
    },
    validations: {
      type: Object,
      default: () => ({})
    },
    validateState: {
      type: Boolean,
      default: null
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  components: {
    vSelect
  },
  methods: {
    setSelected(value) {
      this.$emit("input", value);
    },
    isSelectable(option) {
      return option.selectable !== false;
    }
  }
};
</script>

<style scoped>
/* Invalid field styling for vue-select */
.is-invalid >>> .vs__dropdown-toggle {
  border-color: #f64e60 !important;
  background-color: #ffe2e5 !important;
}

.is-invalid >>> .vs__search,
.is-invalid >>> .vs__search:focus {
  background-color: #ffe2e5 !important;
}

.is-invalid >>> .vs__selected {
  color: #f64e60 !important;
}

.is-invalid >>> .vs__clear,
.is-invalid >>> .vs__open-indicator {
  fill: #f64e60 !important;
}
</style>
